import React, { SVGProps, useId } from "react";
export const PuzzleIcon = (props: SVGProps<SVGSVGElement>) => {
  const a = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      viewBox="0 0 128 128"
      {...props}
    >
      <path
        fill="#b0b0af"
        d="M32.74 59.8c-.42-.42-25.99-6.05-25.99-6.05s-1.49 2.39-1.06 3.8c.24.79 5.82 7.28 11.56 13.25 4.53 4.72 9.68 9.52 10.43 12.26 1.15 4.22 1.27 10.99 1.27 10.99l-16.67 10.18s2.04 10.38 15.26 9.97c12.35-.38 12.99-13.46 16.91-13.53.66-.01 1.57-.24 3.2 1.51 4.04 4.34 11.6 12.72 14.13 15.26 3.38 3.38 5.78 6.76 7.05 6.62 1.27-.14 11.98-9.72 15.08-12.68 3.1-2.96 5.92-6.48 5.92-9.44 0-2.96-4.37-5.21-4.37-5.21l-24.1 2.82L32.74 59.8zM103.62 21.62c.42 0 11.13-5.35 11.13-5.35s5.5 11.13-1.55 17.47c-7.05 6.34-8.6 2.75-11.98 6.48-2.58 2.85-1.27 8.74-1.27 8.74L120.9 69.1s1.17 2.13.33 3.68c-.6 1.1-7.65 8.99-13.11 14.66-2.46 2.55-5.89 3.41-7.75 2.96-4.65-1.13-5.35-4.79-6.2-11.27-.85-6.48-6.43-6.38-8.46-6.06-4.28.68-7.07 3.18-7.07 3.18s-25.2-30.37-24.92-31.22c.28-.85 1.27-7.19-1.69-9.86-2.96-2.68-8.87-4.04-11.13-5.59-2.25-1.55-2.55-4.5-2.14-7.36s18.63-2.83 18.63-2.83 31.42 17.33 31.57 16.63c.14-.74 14.66-14.4 14.66-14.4z"
      />
      <radialGradient
        id={a}
        cx={62.172}
        cy={-28.3}
        r={119.225}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.508} stopColor="#b7d118" />
        <stop offset={0.572} stopColor="#b2d019" />
        <stop offset={0.643} stopColor="#a5cd1d" />
        <stop offset={0.717} stopColor="#8fc922" />
        <stop offset={0.793} stopColor="#70c22a" />
        <stop offset={0.871} stopColor="#48ba34" />
        <stop offset={0.949} stopColor="#18b040" />
        <stop offset={0.981} stopColor="#02ab46" />
      </radialGradient>
      <path
        fill={`url(#${a})`}
        d="M88.12 24.99c.76-2.78-.11-9.61 5.2-14.13s13.57-3.96 18.54.79 5.77 13.68-.11 19.56c-5.88 5.88-8.59 2.6-11.87 5.77-3.28 3.17-2.71 5.77-.68 7.69 2.04 1.92 22.28 23.07 21.71 24.42s-14.36 16.96-16.62 18.09c-2.26 1.13-6.22 1.02-7.01-2.71s.57-11.19-5.09-13.12c-5.65-1.92-8.14-.34-13.68 5.54-5.54 5.88-8.03 12.32-3.51 15.6 4.52 3.28 10.18 1.92 12.44 5.77s-1.13 7.35-7.12 12.89c-5.99 5.54-10.63 10.06-11.42 9.5-.79-.57-17.98-18.77-19.67-20.69-1.7-1.92-4.98-3.62-8.14-.68-3.17 2.94-3.73 12.55-17.07 12.55S9.08 97.36 13.83 91.37s15.26-6.56 15.49-10.63c.1-1.87-5.67-6.91-10.85-12.32C12.38 62.05 6.72 55.3 6.48 54.51c-.45-1.47 12.66-14.36 15.15-16.17s5.31-.68 6.67.79c1.36 1.47 1.7 5.99 2.83 8.59 1.13 2.6 6.44 13.91 19.22 1.02 12.66-12.78.68-18.32-3.39-19.45-4.07-1.13-7-1.5-8.14-5.65-.9-3.28 4.07-7.12 9.27-12.1s8.25-7.58 9.61-7.58c1.36 0 19.56 19.56 21.94 21.82s3.84 2.83 5.54 2.37c1.69-.44 2.6-1.91 2.94-3.16z"
      />
    </svg>
  );
};
